module.exports = __webpack_public_path__ + "media/images/order-history-icon-2ff00e74caa12b750b5369c5be37e13c.svg";